import React from 'react';
import PropTypes from 'prop-types';
import jQuery from 'jquery';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModalHeader from '../common/modal/header';

import MethodSelector from './method-selector';
import Search from './search';
import LocationsList from './locations-list';
import LocationListing from './location-listing';
import AddressForm from './address-form';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;
const { Locations } = Mobi2Go;
const { Customer } = Mobi2Go;
const MapService = Mobi2Go.MapsService;
const { CustomerAddress } = Mobi2Go._class;
const { classNames } = Mobi2Go.helpers;

class LocationsFinder extends React.Component {
    static propTypes = {
        closeModal: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    constructor() {
        super();

        this.state = {
            method: Locations.getDefaultOrderMethod(),
            should_show_method_selector:
                Locations.getPickupAvailableCount() > 0 &&
                Locations.getDeliveryAvailableCount() > 0,
            should_show_pickup_search: Locations.getPickupAvailableCount() > 4,
            search_query: '',

            force_search_autocomplete_hide: false,
            is_search_input_focused: false,
            is_mouseover_search: false,

            search_autocomplete_highlighted_item: null,
            search_autocomplete_selected_item: null,
            search_autocomplete_list: [],

            location_list: [],
            address: new CustomerAddress({}),

            is_address_available: null,
            is_showing_all_delivery_locations: false,
            is_loading: false,

            emphasise_address_unavailable_message: false,

            region_list: _.map(
                Locations.getByRegion(),
                (locations, region) => ({
                    id: region,
                    type: 'region',
                    description: region,
                    locations,
                    subtext: (
                        <span>
                            <span className="m2g-icon m2g-icon--location m2g-autocomplete-item-subtext-icon" />
                            {locations.length === 1
                                ? '1 store'
                                : `${locations.length} stores`}
                        </span>
                    ),
                })
            ),
            is_test_order: Order.isTest(),
        };

        Order.bind('updateIsTest', is_test_order => {
            this.setState({ is_test_order });
            this.updateLocationList();
        });

        Mobi2Go.bind('MapsService', 'coordinatesAvailable', () => {
            const { method } = this.state;
            if (method === 'pickup') {
                this.updateLocationList();
            }
        });
    }

    UNSAFE_componentWillMount() {
        this.updateLocationList();
    }

    onMethodChange = method => {
        const { method: current_method } = this.state;
        const state = { method };
        if (method !== current_method) {
            state.search_query = '';
            state.search_autocomplete_selected_item = null;
        }

        this.setState(state, () => {
            this.updateAutocompleteList();
            this.updateLocationList(() => {
                this.updateIsAddressAvailable();
            });
        });
    };

    onSearchQueryChange = search_query => {
        const { search_autocomplete_selected_item } = this.state;
        this.setState(
            {
                search_query,
                force_search_autocomplete_hide: false,
                search_autocomplete_selected_item:
                    search_query !== ''
                        ? search_autocomplete_selected_item
                        : null,
            },
            () => {
                this.debouncedUpdateAutocompleteList();
                this.updateIsAddressAvailable();
            }
        );
    };

    onSearchInputFocusChange = is_search_input_focused => {
        this.setState(
            {
                is_search_input_focused,
                force_search_autocomplete_hide: false,
            },
            () => this.updateAutocompleteList()
        );
    };

    onSearchMouseEnterChange = is_mouseover_search => {
        this.setState({ is_mouseover_search });
    };

    onSelectedItemChange = search_autocomplete_selected_item => {
        const { search_query } = this.state;
        this.setState(
            {
                search_autocomplete_selected_item,
                search_query: search_autocomplete_selected_item
                    ? search_autocomplete_selected_item.description
                    : search_query,
                force_search_autocomplete_hide: true,
                is_showing_all_delivery_locations: false,
            },
            () => {
                this.updateAutocompleteList();
                this.updateLocationList(() => {
                    this.updateIsAddressAvailable();
                });
            }
        );
    };

    onHighlightedItemChange = search_autocomplete_highlighted_item => {
        this.setState({ search_autocomplete_highlighted_item });
    };

    onLocationClick = (location, method) => {
        UI.warnings.warnForUnavailableAndRestrictedProducts(
            location,
            accepted => {
                if (accepted) {
                    this.setOrderLocationAndMethodAndClose(location, method);
                }
            }
        );
    };

    setOrderLocationAndMethodAndClose(location, method) {
        const { address } = this.state;
        const { closeModal } = this.props;

        if (method === 'delivery') {
            try {
                CustomerAddress.prototype.validate(address);
            } catch (error) {
                UI.centeredAlert({
                    title: 'Invalid address',
                    body: error.message,
                });
                return;
            }

            Order.set({ location, method });
            Order.setAddressAfterCustomerSet(address);
        } else {
            Order.set({ location, method });
        }

        closeModal();

        _.defer(() => {
            if (!UI.ExternalModal.isOpen()) {
                UI.helpers.scrollTo(
                    '[data-view="order-location"]',
                    () => {
                        setTimeout(() => {
                            UI.alert({
                                title: 'Store set',
                                body: `Ordering from ${location.name}`,
                                el: jQuery(
                                    '[data-view="order-location"] [data-order-location]'
                                ).parent(),
                                placement: 'left',
                                primary_button: null,
                                temp: true,
                                highlight_element: true,
                            });
                        }, 250);
                    },
                    true,
                    -150
                );
            }
        });
    }

    onSavedAddressDeleteClick = saved_address => {
        Customer.removeAddressById(saved_address.id);
        this.updateAutocompleteList();
        this.updateIsAddressAvailable();
    };

    updateAutocompleteList = () => {
        const {
            method,
            region_list,
            search_query,
            search_autocomplete_highlighted_item,
            is_test_order,
        } = this.state;
        let list = [];
        let locations = [];
        let matching_search_item_count = 0;

        let search_query_lowercase = search_query.toLowerCase();
        if (search_query_lowercase.trim) {
            search_query_lowercase = search_query_lowercase.trim();
        }

        if (method === 'pickup') {
            // Match regions with search query
            const regions = _.map(region_list, region => {
                const matched_substrings = [];

                if (search_query_lowercase) {
                    const index = region.description
                        .toLowerCase()
                        .indexOf(search_query_lowercase);
                    if (index !== -1) {
                        matched_substrings.push({
                            offset: index,
                            length: search_query_lowercase.length,
                        });
                        matching_search_item_count += 1;
                    }
                }

                return _.extend(region, {
                    matched_substrings,
                });
            });

            list = list.concat(regions);

            // Search locations that match
            if (search_query) {
                locations = Locations.search({
                    name: search_query,
                    method: 'pickup',
                    status: is_test_order ? null : 'active',
                });
                locations = Locations.rankLocationsForPickUpOrEatIn(locations);
                locations = _.map(locations, location => {
                    const index = location.name
                        .toLowerCase()
                        .indexOf(search_query_lowercase);
                    const matched_substrings = [];
                    if (index !== -1) {
                        matched_substrings.push({
                            offset: index,
                            length: search_query.length,
                        });
                        matching_search_item_count += 1;
                    }

                    const is_open = location.isOpenForMethod(method);
                    let subtext = '';
                    if (is_open) {
                        if (method === 'pickup') {
                            subtext = `Pick up in ${location.wait_times.pickup} minutes`;
                        } else {
                            subtext = `Delivers in ${location.wait_times.pickup} minutes`;
                        }
                    } else {
                        subtext = location.getClosingTimeSentence();
                    }

                    // Remove parent 'region' item if it has a matching name
                    // and only a single location to avoid double ups
                    list = _.filter(list, region => {
                        return (
                            region.locations.length !== 1 ||
                            region.locations[0].id !== location.id ||
                            region.description !== location.name
                        );
                    });

                    return _.extend(location, {
                        id: location.id,
                        type: 'location',
                        description: location.name,
                        subtext,
                        matched_substrings,
                        is_open,
                    });
                });

                list = list.concat(locations);
            }

            // If there are items that match search, remove all non-matching items
            if (locations.length && matching_search_item_count !== 0) {
                list = _.filter(list, item => item.matched_substrings.length);
            }

            // Sort by best match
            list = list.sort((a, b) => {
                const a_substrings = a.matched_substrings;
                const b_substrings = b.matched_substrings;

                if (a_substrings.length && b_substrings.length) {
                    if (a_substrings[0].length === b_substrings[0].length) {
                        if (a.type === b.type) {
                            return (
                                a_substrings[0].offset - b_substrings[0].offset
                            );
                        }

                        return a.type === 'region' ? -1 : 1;
                    }

                    return b_substrings[0].length - a_substrings[0].length;
                }

                if (!a_substrings.length || !b_substrings.length) {
                    if (!a_substrings.length && !b_substrings.length) {
                        if (a.type === b.type) {
                            if (
                                a.description.toLowerCase() <
                                b.description.toLowerCase()
                            ) {
                                return -1;
                            }
                            if (
                                a.description.toLowerCase() >
                                b.description.toLowerCase()
                            ) {
                                return 1;
                            }
                            return 0;
                        }
                        if (a.type === 'region') {
                            return -1;
                        }
                        if (b.type === 'region') {
                            return 1;
                        }
                        return 0;
                    }

                    if (a_substrings.length) {
                        return -1;
                    }
                    if (b_substrings.length) {
                        return 1;
                    }
                    return 0;
                }

                if (a.type === b.type) {
                    if (
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                    ) {
                        return -1;
                    }
                    if (
                        a.description.toLowerCase() >
                        b.description.toLowerCase()
                    ) {
                        return 1;
                    }
                    return 0;
                }

                return 0;
            });

            this.setState({
                search_autocomplete_list: list,
                search_autocomplete_highlighted_item:
                    list.length &&
                    (!search_autocomplete_highlighted_item ||
                        this.hasAutocompleteListChanged(list))
                        ? list[0]
                        : search_autocomplete_highlighted_item,
            });
        } else if (method === 'delivery') {
            let customer_addresses = [];
            if (Order.getCustomer()) {
                const addresses = Order.getCustomer()
                    .getAddresses()
                    .filter(address => address.id);
                customer_addresses = _.map(addresses, address => {
                    const matched_substrings = [];

                    if (search_query_lowercase) {
                        const index = address
                            .toString()
                            .toLowerCase()
                            .indexOf(search_query_lowercase);
                        if (index !== -1) {
                            matched_substrings.push({
                                offset: index,
                                length: search_query.length,
                            });
                        }
                    }
                    return {
                        id: address.id,
                        type: 'saved_address',
                        description: address.toString(),
                        address,
                        matched_substrings,
                    };
                });
            }

            // Return address suggestions
            MapService.getPlacePredictions(
                search_query_lowercase,
                predictions => {
                    list = predictions || [];
                    list = _.map(list, item =>
                        _.extend(item, { type: 'address' })
                    );
                    list = customer_addresses.concat(list);

                    // Sort saved addresses with matches to the top
                    // Sort saved addresses without matches to bottom
                    list = list.sort((a, b) => {
                        if (a.type === 'saved_address') {
                            if (a.matched_substrings.length > 0) {
                                return -1;
                            }
                            return 1;
                        }

                        if (b.type === 'saved_address') {
                            if (b.matched_substrings.length > 0) {
                                return 1;
                            }
                            return -1;
                        }

                        return 0;
                    });

                    this.setState({
                        search_autocomplete_list: list,
                        search_autocomplete_highlighted_item:
                            list.length &&
                            (!search_autocomplete_highlighted_item ||
                                this.hasAutocompleteListChanged(list))
                                ? list[0]
                                : search_autocomplete_highlighted_item,
                    });
                }
            );
        }
    };

    // eslint-disable-next-line react/sort-comp
    debouncedUpdateAutocompleteList = _.debounce(
        this.updateAutocompleteList,
        50,
        {
            maxWait: 500,
        }
    );

    emphasisAddressUnavailableMessage = () => {
        this.setState({
            emphasise_address_unavailable_message: true,
        });

        clearTimeout(this.emphasisAddressUnavailableMessage.animation_timeout);
        this.emphasisAddressUnavailableMessage.animation_timeout = setTimeout(
            () => {
                this.setState({
                    emphasise_address_unavailable_message: false,
                });
            },
            330
        );
    };

    updateIsAddressAvailable() {
        const {
            method,
            search_autocomplete_selected_item,
            location_list,
        } = this.state;

        const is_address_available =
            method === 'delivery' &&
            search_autocomplete_selected_item &&
            (search_autocomplete_selected_item.type === 'address' ||
                search_autocomplete_selected_item.type === 'saved_address') &&
            location_list.length > 0;

        if (!is_address_available) {
            setTimeout(this.emphasisAddressUnavailableMessage, 320);
        }

        this.setState({
            is_address_available,
        });
    }

    hasAutocompleteListChanged(list) {
        // May be more efficient just change to highlighted item on query change?
        const list_signature = _.reduce(
            list,
            (ids, list_item) => ids + list_item.id,
            ''
        );

        if (
            list_signature !==
            this.hasAutocompleteListChanged.prev_list_signature
        ) {
            this.hasAutocompleteListChanged.prev_list_signature = list_signature;
            return true;
        }

        return false;
    }

    updateLocationList(callback) {
        const {
            search_autocomplete_selected_item: selected_item,
            is_test_order,
        } = this.state;
        let location_list = [];
        const include_hidden_and_inactive = is_test_order;

        if (selected_item) {
            switch (selected_item.type) {
                case 'location': {
                    location_list = [Locations.getById(selected_item.id)];
                    break;
                }
                case 'region': {
                    location_list = Locations.rankLocationsForPickUpOrEatIn(
                        selected_item.locations
                    );
                    break;
                }
                case 'address': {
                    MapService.getPlaceDetails(selected_item, async details => {
                        this.setState({
                            is_loading: true,
                        });

                        // pseudo Address object
                        const address_props = CustomerAddress.prototype.mapGmapsPlaceDetailFields(
                            details,
                            selected_item.description
                        );
                        const address = new CustomerAddress(address_props);

                        location_list = await Locations.getAllWithDeliveryAvailableToAddressAsync(
                            address,
                            { include_hidden_and_inactive }
                        );

                        Order.log('Delivery map polygon address query', {
                            address: address.get(),
                        });

                        this.setState(
                            {
                                is_loading: false,
                                location_list,
                                address,
                            },
                            callback
                        );
                    });

                    return;
                }
                case 'saved_address': {
                    (async () => {
                        this.setState({
                            is_loading: true,
                        });
                        location_list = await Locations.getAllWithDeliveryAvailableToAddressAsync(
                            selected_item.address,
                            { include_hidden_and_inactive }
                        );
                        this.setState(
                            {
                                is_loading: false,
                                location_list,
                                address: selected_item.address,
                            },
                            callback
                        );
                    })();

                    return;
                }
                default:
                    break;
            }
        } else {
            location_list = Locations.getAllWithPickUpOrEatinAvailable({
                include_hidden_and_inactive,
            });
        }

        this.setState({ location_list }, callback);
    }

    render() {
        const {
            address,
            method,
            search_autocomplete_list,
            search_autocomplete_highlighted_item,
            search_autocomplete_selected_item,
            force_search_autocomplete_hide,
            is_search_input_focused,
            location_list,
            should_show_method_selector,
            should_show_pickup_search,
            search_query,
            is_mouseover_search,
            is_address_available,
            emphasise_address_unavailable_message,
            is_showing_all_delivery_locations,
            is_loading,
            is_test_order,
        } = this.state;
        const { closeModal } = this.props;

        const show_search_prompt_message =
            method === 'delivery' && !search_autocomplete_selected_item;
        const show_address_unavailable_message =
            !is_loading &&
            search_autocomplete_selected_item &&
            (search_autocomplete_selected_item.type === 'address' ||
                search_autocomplete_selected_item.type === 'saved_address') &&
            location_list.length === 0;
        const { t } = this.props;

        return (
            <div
                className="m2g-locations-finder"
                data-delivery-only={
                    !should_show_method_selector && method === 'delivery'
                }
                data-method={method}
            >
                <ModalHeader
                    headerText={t('find_your_store')}
                    onClose={closeModal}
                />

                <div className="m2g-modal-body">
                    {should_show_method_selector && (
                        <MethodSelector
                            method={method}
                            onChange={this.onMethodChange}
                        />
                    )}

                    {(method === 'delivery' ||
                        (should_show_pickup_search && method === 'pickup')) && (
                        <Search
                            method={method}
                            search_query={search_query}
                            autocomplete_list={search_autocomplete_list}
                            selected_item={search_autocomplete_selected_item}
                            highlighted_item={
                                search_autocomplete_highlighted_item
                            }
                            force_autocomplete_hide={
                                force_search_autocomplete_hide
                            }
                            is_search_input_focused={is_search_input_focused}
                            is_mouseover_search={is_mouseover_search}
                            onMethodChange={this.onMethodChange}
                            onItemSelect={this.onSelectedItemChange}
                            onItemHighlight={this.onHighlightedItemChange}
                            onInputFocusChange={this.onSearchInputFocusChange}
                            onMouseEnterChange={this.onSearchMouseEnterChange}
                            onSearchQueryChange={this.onSearchQueryChange}
                            onSelectedRegionChange={this.onSelectedRegionChange}
                            onSavedAddressDeleteClick={
                                this.onSavedAddressDeleteClick
                            }
                        />
                    )}

                    {method === 'pickup' && (
                        <LocationsList
                            method={method}
                            onLocationClick={this.onLocationClick}
                            list={location_list}
                            is_test_order={is_test_order}
                        />
                    )}

                    <div
                        className={classNames(
                            'm2g-locations-finder-message',
                            'm2g-locations-finder-message--prompt-search',
                            {
                                'm2g-locations-finder-message--hidden': !show_search_prompt_message,
                            }
                        )}
                    >
                        <div className="m2g-locations-finder-message-icon m2g-icon m2g-icon--search" />
                        <div className="m2g-locations-finder-message-content">
                            <strong className="m2g-locations-finder-message-content-title">
                                {t('address_search')}
                            </strong>
                            <br />
                            <div className="m2g-locations-finder-message-content-message">
                                {t('enter_your_address')}
                            </div>
                        </div>

                        {!is_search_input_focused && (
                            <div className="m2g-locations-finder-message-arrow-icon m2g-icon m2g-icon--up" />
                        )}
                    </div>

                    {is_loading && method === 'delivery' && (
                        <div className="m2g-locations-finder-loader m2g-icon m2g-icon--spinner" />
                    )}

                    <div
                        className={classNames(
                            'm2g-locations-finder-message',
                            'm2g-locations-finder-message--address-unavailable',
                            {
                                'm2g-locations-finder-message--hidden': !show_address_unavailable_message,
                                'm2g-locations-finder-message--emphasis': emphasise_address_unavailable_message,
                            }
                        )}
                    >
                        <div className="m2g-locations-finder-message-icon m2g-icon m2g-icon--alert" />
                        <div className="m2g-locations-finder-message-content">
                            <strong className="m2g-locations-finder-message-content-title">
                                {t('delivery_unavailable')}
                            </strong>
                            <br />
                            <div className="m2g-locations-finder-message-content-message">
                                {t('address_outside_delivery_area')}
                            </div>
                        </div>
                        <div className="m2g-locations-finder-message-arrow-icon m2g-icon m2g-icon--up" />
                    </div>

                    {!is_loading && method === 'delivery' && (
                        <AddressForm
                            onTypeChange={type => {
                                address.type = type;
                                this.setState({ address });
                            }}
                            onNameChange={name => {
                                address.name = name;
                                this.setState({ address });
                            }}
                            onStreetNumberChange={number => {
                                address.street_number = number;
                                this.setState({ address });
                            }}
                            onStreetNameChange={name => {
                                address.street_name = name;
                                this.setState({ address });
                            }}
                            onSpecificNumberChange={specific_number => {
                                address.specific_number = specific_number;
                                this.setState({ address });
                            }}
                            onCommentChange={comment => {
                                address.comment = comment;
                                this.setState({ address });
                            }}
                            onSuburbChange={suburb => {
                                address.suburb = suburb;
                                this.setState({address});
                            }}
                            onPostcodeChange={postcode => {
                                address.post_code = postcode;
                                this.setState({address});
                            }}
                            is_showing={!!is_address_available}
                            address={address}
                        />
                    )}

                    {
                        <div
                            className={classNames(
                                'm2g-locations-finder-delivery-locations',
                                'm2g-well',
                                {
                                    'm2g-locations-finder-delivery-locations--has-multiple-options':
                                        location_list.length > 1,
                                    'm2g-locations-finder-delivery-locations--hidden':
                                        method !== 'delivery' ||
                                        !is_address_available ||
                                        is_loading,
                                    'm2g-locations-finder-delivery-locations--all-showing': is_showing_all_delivery_locations,
                                }
                            )}
                        >
                            {location_list.length && (
                                <div className="m2g-locations-finder-delivery-locations-list">
                                    {location_list.map(location => (
                                        <LocationListing
                                            key={location.id}
                                            method="delivery"
                                            onMethodClick={() => {
                                                this.onLocationClick(
                                                    location,
                                                    'delivery'
                                                );
                                            }}
                                            location={location}
                                            is_test_order={is_test_order}
                                        />
                                    ))}
                                </div>
                            )}

                            {location_list.length > 1 && (
                                <div
                                    role="button"
                                    tabIndex={0}
                                    onKeyPress={() => {}}
                                    className="m2g-locations-finder-delivery-locations-show-more-or-less"
                                    onClick={() => {
                                        this.setState({
                                            is_showing_all_delivery_locations: !is_showing_all_delivery_locations,
                                        });
                                    }}
                                >
                                    {is_showing_all_delivery_locations ? (
                                        <span>
                                            <span className="m2g-locations-finder-delivery-locations-show-more-or-less-icon m2g-icon m2g-icon--chevron-down" />
                                            &nbsp;
                                            <span className="m2g-locations-finder-delivery-locations-show-more-or-less-link">
                                                {t('edit_address')}
                                            </span>
                                        </span>
                                    ) : (
                                        <span>
                                            <span className="m2g-locations-finder-delivery-locations-show-more-or-less-icon m2g-icon m2g-icon--chevron-down" />
                                            &nbsp;
                                            <span className="m2g-locations-finder-delivery-locations-show-more-or-less-link">
                                                {t('stores_available', {
                                                    count: location_list.length,
                                                })}
                                            </span>
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default forwardRefWithTranslation('locations.finder')(LocationsFinder);
